import {
  Mark,
  mergeAttributes,
} from '@tiptap/core'


export default Mark.create({
  name: 'info',

  addAttributes() {
    return {
      info: {
        default: '',
        renderHTML: attributes => {
          return {
            info: attributes.info
          }
        },
      },
      src: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[info]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setInfo: () => ({ commands }) => {
        return commands.setMark('info')
      },
      toggleInfo: () => ({ commands }) => {
        return commands.toggleMark('info')
      },
      unsetInfo: () => ({ commands }) => {
        return commands.unsetMark('info')
      },
      setInfoValue: value => ({ commands }) => {
        commands.extendMarkRange(this.name)
        commands.updateAttributes(this.name, { info: value })
      },
      setMediaSrc: src => ({ commands }) => {
        commands.extendMarkRange(this.name)
        commands.updateAttributes(this.name, { src: src })
      },
    }
  },
})